export default {
  title: 'Period',
  today: 'Today',
  sinceCreation: 'Since creation',
  lastXDays: 'Last {0} days',
  thisMonth: 'This month'
}